module.exports = __webpack_public_path__ + "img/9788984314504.e44b6a5c.jpg";